import type { GenericObject, GenericValidateFunction, InvalidSubmissionContext, SubmissionContext } from 'vee-validate'
import type { InputHTMLAttributes } from 'vue'

export enum LiveValidateType {
    INPUT = 'input',
    BLUR = 'blur',
    CHANGE = 'change',
}

export type LiveValidateTypeUnion = `${LiveValidateType}`

export interface UIInputBaseProps {
    name: string
    placeholder?: string
    type?: InputHTMLAttributes['type']
    disabled?: boolean
    dataTest?: string
    errorMessages?: string | string[]
    rules?: GenericValidateFunction<any>[]
    autofocus?: boolean
    autocomplete?: string
    liveValidate?: LiveValidateTypeUnion
    staticLabel?: boolean
}

export interface UIFormValidSubmitEvent<TValues extends GenericObject = any> {
    values: TValues
    context: SubmissionContext<TValues>
}

export interface UIFormInvalidSubmitEvent {
    context: InvalidSubmissionContext
}
